import React from 'react';

import CUSTODIAN_AGREEMENT_STATE_ENUM from '@api/requests/applications/enums/CUSTODIAN_AGREEMENT_STATE_ENUM.enum';
import CustodianAgreementInterface from '@api/requests/applications/interfaces/CustodianAgreementInterface.interface';

import SignedIcon from '@mui/icons-material/CheckCircle';

import PendingIcon from 'jsx:@assets/svgs/pending.svg';

export function isAgreementSigned(agreement: CustodianAgreementInterface): boolean {
	return agreement.state === CUSTODIAN_AGREEMENT_STATE_ENUM.SIGNED;
}

export function isAgreementRequired(agreement: CustodianAgreementInterface): boolean {
	return agreement.state === CUSTODIAN_AGREEMENT_STATE_ENUM.REQUIRED;
}

export function getAgreementStatusLabel(agreement: CustodianAgreementInterface): string {
	return isAgreementSigned(agreement) ? 'Signed' : 'Unsigned';
}

export function getAgreementMandatorityLabel(agreement: CustodianAgreementInterface): string | null {
	if (isAgreementSigned(agreement)) return null;

	return isAgreementRequired(agreement) ? 'Required' : 'Optional';
}

export function getAgreementStatusIcon(agreement: CustodianAgreementInterface) {
	return isAgreementSigned(agreement) ? (
		<SignedIcon sx={{ color: theme => theme.palette.success.main }} />
	) : (
		<PendingIcon />
	);
}

export function getUnsignedRequiredAgreements(
	agreements: CustodianAgreementInterface[] = [],
): CustodianAgreementInterface[] {
	return agreements.filter(isAgreementRequired);
}
